export const TIME_BILLING_URL_PARAMS = {
  EXPAND: "expand",
} as const;
